"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHasOpenedPopover = exports.setHasOpenedDialog = void 0;
var _ = require(".");
const setHasOpenedPopover = value => (0, _.dispatchEvent)(_.HAS_OPENED_POPOVER, value);
exports.setHasOpenedPopover = setHasOpenedPopover;
const setHasOpenedDialog = value => (0, _.dispatchEvent)(_.HAS_OPENED_DIALOG, value);
exports.setHasOpenedDialog = setHasOpenedDialog;